import { Spin } from 'antd';
import React, { useState } from 'react';
const Iframe = (props) => {
    let iframe_ref = null;
    const [loading, setloading] = useState(false)
    const writeHTML = (frame) => {
        setloading(true)
        if (!frame) {
            return;
        }
        iframe_ref = frame;
        let doc = frame.contentDocument;
        doc?.open();
        doc?.write(props.content);
        doc?.close();
        frame.style.width = '100%';
        frame.style.height = '600px'; //`${frame.contentWindow.document.body.scrollHeight}px`;
        frame.style.overflow = 'scroll';
        setloading(false)
    };
    return (
        <div ref={props.printRef}>
           { loading ?  <Spin
              className="d-flex justify-content-center w-100"
              size="small"
            ></Spin> : 
             <iframe
          title="html-iframe"
          srcDoc={props.content}  // Inject HTML directly into iframe
          width="100%"
          height="600px"
        //   frameBorder="0"
        />}
            {/* <iframe src="about:blank" ref={writeHTML}
            />} */}
        </div>
    );
};
export default Iframe;